import React, { useContext, useEffect, useState } from "react";
import OrganizationItem from "./PrivillgeManagerItem";
import OrganizationDetailsModel from "./PrivillageManagerDetailsModel";
import OrganizationAddModel from "./PrevillageManagerAddModel";

import { toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-phone-number-input/style.css";

import { useForm } from "react-hook-form";
import TopLoadingBar from "../topLoadingBar/topLoadingBar";
import {
  Add_PrivillageList,
  Delete_PrivillageList,
  Ditails_PrivillageList,
  Edit_PrivillageList,
  ModuleAccessList,
  ModuleList,
  PrivillageList,
} from "../../api/PrivillageApi/PrivillageApi";
import PrivillageMasterContext from "../../context/PrivillageMasterContext/PrivillageMasterContext";
import { useNavigate } from "react-router";
import SocketContext from "../../context/SocketContext/SocketContext";
import { userLogout } from "../../auth/Logout";
const Organization = () => {
  const {
    setformvalue,
    perModule,
    setPerModule,
    setModuleList,
    setModuleChaildList,
    setModuleAccessList,

    setahoeDataModel,
    setModal,
    modal,
    sortOrder,
    setSortOrder,
    sortBy,
    setSortBy,
    filter,
    editIndex,
    seteditIndex,
    uuid,
    setUuid,

    setName,
    name,

    setIsAddHandle,
    progress,
    setProgress,
    togglesubmit,
    setToggle,
    val,

    setIsMenuOpen,
    searchSuppliar,
    setsearchSuppliar,
    setChialdPerModule,
    setSearchChild,
    moduleAccess,
    setModualAccess,

    method,
    setMethod,
    urls,
    setUrls,

    setShowModule,
    setPerModuleName,
    setChiModuleName,
    setChiModule,
    setmodualName,
  } = useContext(PrivillageMasterContext);
  const history = useNavigate();
  const { socket } = useContext(SocketContext);
  const [pageSize, setPageSize] = useState(10);
  const [modulepageSize] = useState(10);
  const [ChaildmodulepageSize] = useState(10);
  const [modualAccessPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [record, setRecord] = useState(0);

  const onMenuOpen = () => {
    setIsMenuOpen(true);
  };

  const onMenuClose = () => setIsMenuOpen(false);

  /**
   * privillage get list function call
   */

  const getData = async () => {
    try {
      let paramsObj = {
        pageNumber: page,
        recordsPerPage: pageSize,
        sortOrder,
        sortBy,
        search: val,
      };
      if (filter.length) {
        paramsObj["search"] = { name: filter };
      }
      const { data } = await PrivillageList(paramsObj);
      if (data.status === 200) {
        setformvalue(data.payload.data);
        setRecord(data.pager.totalRecords);
      } else {
        setformvalue([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        userLogout(history, socket);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  useEffect(() => {
    getData();
    setProgress(100);
  }, [page, pageSize, sortOrder, sortBy, filter]);

  /**
   * get module list function call
   */

  const getModuleData = async () => {
    try {
      let paramsObj = {
        recordsPerPage: modulepageSize,
        search: { parentId: null, name: searchSuppliar },
      };
      const { data } = await ModuleList(paramsObj);
      if (data.status === 200) {
        setModuleList(data.payload.data);
      } else {
        setModuleList([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        userLogout(history, socket);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  useEffect(() => {
    getModuleData();
  }, [modulepageSize, searchSuppliar, perModule]);

  /**
   * modual access list functionc call
   */

  const handleChaildChange1 = async (chialdperModule) => {
    setChialdPerModule(chialdperModule.value);
    try {
      let paramsObj = {
        recordsPerPage: modualAccessPageSize,
        moduleId: chialdperModule.value,
      };
      const { data } = await ModuleAccessList(paramsObj);
      if (data.status === 200) {
        setModuleAccessList(data.payload.data);
      } else {
        setModuleAccessList([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        userLogout(history, socket);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  /** dropdown search */

  const handleChaildInputChange1 = (chialdperModule) => {
    setSearchChild(chialdperModule);
  };

  /**
   * dropdown search
   */

  const handleModualAccessChange2 = (moduleAccess) => {
    setModualAccess(moduleAccess.map((x) => x.value));
  };

  const onModualAccessChange = (moduleAccess, { action, prevInputValue }) => {
    if (action === "input-change") return moduleAccess;
    if (action === "menu-close") {
      if (prevInputValue) setIsMenuOpen(true);
      else setIsMenuOpen(undefined);
    }
    return prevInputValue;
  };

  /**
   * dropdown select and value change function call
   */

  const handleChange = async (perModule) => {
    setPerModule(perModule.value);
    try {
      let paramsObj = {
        recordsPerPage: ChaildmodulepageSize,
        search: { parentId: perModule.value },
      };
      const { data } = await ModuleList(paramsObj);
      if (data.status === 200) {
        setModuleChaildList(data.payload.data);
      } else {
        setModuleChaildList([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        userLogout(history, socket);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  /**
   * dropdown search
   */
  const handleInputChange = (perModule) => {
    setsearchSuppliar(perModule);
  };

  /**
   * plush button click to open popup function call
   */

  const AddModel = () => {
    setModal(true);
    setToggle(true);
  };

  /**
   * edit previllage list function call
   */

  const editHandle = async (id) => {
    setUuid(id);
    try {
      const { data } = await Ditails_PrivillageList(id);
      if (data.status === 200) {
        setToggle(false);
        setIsAddHandle(false);
        seteditIndex(id);

        setName(data.payload.data.name);
        setUrls(data.payload.data.url);
        setMethod(data.payload.data.method);

        if (data.payload.moduleList.length) {
          setPerModule(data.payload.moduleList.map((elem) => elem.parent.id));
          setPerModuleName(
            data.payload.moduleList.map((elem) => elem.parent.name)
          );
          setChiModule(data.payload.moduleList.map((elem) => elem.id));
          setChiModuleName(data.payload.moduleList.map((elem) => elem.name));

          setmodualName(
            data.payload.moduleList[0].moduleAccess.map((e) => ({
              label: e.accessName,
              value: +e.accessId,
            }))
          );
          setModualAccess(
            data.payload.moduleList[0].moduleAccess.map((e) => +e.accessId)
          );
        }

        setModal(true);
      } else {
        setformvalue([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        userLogout(history, socket);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  const { register } = useForm();

  /**
   * empty feild function call
   */

  const emptyFeild = () => {
    setModualAccess([]);
    setName("");
    setUrls("");
    setMethod("");
    setPerModule("");
    setPerModuleName("");
    setChiModule("");
    setChiModuleName("");
    setmodualName("");
  };

  /**
   * fill feild function call
   */

  const fillFeild = () => {
    setName(name);
    setMethod(method);
    setUrls(urls);
    setModualAccess([moduleAccess]);
  };

  /**
   * create privillage and edit privillage function call
   */

  const onSubmit = async (e) => {
    e.preventDefault();
    let formData;
    if (editIndex !== -1 && !togglesubmit) {
      formData = {
        name: name,
        method: method,
        url: urls,
        moduleAccessIds: moduleAccess,
        privilegeId: uuid,
      };

      try {
        const { data } = await Edit_PrivillageList(formData, uuid);
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
          });
          setModal(false);
          getData();
          emptyFeild();
        } else {
          fillFeild();
        }
      } catch (error) {
        if (error?.response?.data?.status === 401) {
          userLogout(history, socket);
        }
        toast.error(error?.response?.data?.message, {
          autoClose: 1000,
          transition: Zoom,
        });
      }
    } else {
      formData = {
        name: name,
        method: method,
        url: urls,
        moduleAccessIds: moduleAccess,
      };

      try {
        const { data } = await Add_PrivillageList(formData);
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
            transition: Zoom,
          });
          setModal(false);
          getData();
          emptyFeild();
        } else {
          fillFeild();
        }
      } catch (error) {
        if (error?.response?.data?.status === 401) {
          userLogout(history, socket);
        }
        toast.error(error?.response?.data?.message, {
          autoClose: 1000,
          transition: Zoom,
        });
      }
    }
  };

  /**
   * show previllage to function call
   */

  const showHandle = async (id) => {
    setUuid(id);

    try {
      const { data } = await Ditails_PrivillageList(id);
      if (data.status === 200) {
        setahoeDataModel(true);
        setName(data.payload.data.name);
        setUrls(data.payload.data.url);
        setMethod(data.payload.data.method);
        setShowModule(data.payload.moduleList);
      } else {
        setformvalue([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        userLogout(history, socket);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  /**
   * delete privillage to function call
   */

  const DeleteHandle = async (id) => {
    let formData = {
      privilegeId: id,
    };
    try {
      const { data } = await Delete_PrivillageList(formData);
      if (data.status === 200) {
        toast.success(data.message, {
          autoClose: 1000,
        });
        getData();
      } else {
      }
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        userLogout(history, socket);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  /**
   * sorting function call
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  /**
   * close popup to function call
   */

  const close = () => {
    setModal(!modal);
    emptyFeild();
  };

  return (
    <>
      <div>
        <TopLoadingBar progress={progress} setProgress={setProgress} />
        <OrganizationAddModel
          onSubmit={onSubmit}
          register={register}
          handleInputChange={handleInputChange}
          handleChange={handleChange}
          onMenuOpen={onMenuOpen}
          onMenuClose={onMenuClose}
          handleChaildChange1={handleChaildChange1}
          handleChaildInputChange1={handleChaildInputChange1}
          handleModualAccessChange2={handleModualAccessChange2}
          onModualAccessChange={onModualAccessChange}
          close={close}
        />
        <OrganizationDetailsModel />
        <OrganizationItem
          sorting={sorting}
          editHandle={editHandle}
          showHandle={showHandle}
          AddModel={AddModel}
          setPage={setPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
          page={page}
          record={record}
          DeleteHandle={DeleteHandle}
        />
      </div>
    </>
  );
};
export default Organization;
